<script>
    import Nav from "../components/navigation.svelte"
    import Cell from "../components/list_cell.svelte"
    import { onMount } from "svelte";
    let items = {
        0 : {
            "id" : 0,
            "c-name" : "RandomCorp",
            "job-title" : "Frontend Developer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        1 :{
            "id" : 1,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        2 : {
            "id" : 2,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        3 : {
            "id" : 3,
            "c-name" : "RandomCorp",
            "job-title" : "Frontend Developer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        4 : {
            "id" : 4,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        5 : {
            "id" : 5,
            "c-name" : "RandomCorp",
            "job-title" : "Database specialist",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        6 : {
            "id" : 6,
            "c-name" : "RandomCorp",
            "job-title" : "Backend Engineer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        7 : {
            "id" : 7,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "part-time 60%-80%",
            "email-address" : "randomcorp@jobs.com"
        },
        8 : {
            "id" : 8,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com"
        },
        9 : {
            "id" : 9,
            "c-name" : "RandomCorp",
            "job-title" : "Backend Developer",
            "occupation" : "part-time 60%-80%",
            "email-address" : "randomcorp@jobs.com"
        }
    }

    let checked = {};
    let checkedInitialized = false;

    onMount(() => {

        Object.keys(items).forEach(item => {
            checked[item] = false;
        });

        checkedInitialized = true;

    })

    let getChecked = (cell_id) => {
        checked[cell_id] = !checked[cell_id];
    };

    let sendApplication = (array) => {
        let companies = [];

        Object.keys(checked).forEach(key => {
            if (checked[key]) {
                companies.push(key);
                delete items[key]
                delete checked[key];
            }

        })
        items = JSON.parse(JSON.stringify(items));
        checked = checked;
        return companies;
    }


</script>

<Nav/>

<section>

    <div class="headline_action">
        <h2>Send your application</h2>
        <button on:click={sendApplication(checked)}>Send</button>
    </div>

    {#if checkedInitialized}

        {#each Object.values(items) as item}

            <Cell cell_data={item} getChecked={getChecked} checked={checked[item['id']]}/>

        {/each}

    {/if}

</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .headline_action {
        display: flex;
        justify-content: space-between;
        width: 96%;
        margin: 4vw 0;
    }
    h2 {
      font-size: 4vw;
      font-weight: 600;
    }
    button {
        background-color: transparent;
        padding: 0 4vw;
        font-family: "Raleway";
        outline: none;
    }
</style>

